import { isFlagOn } from "../utils";
import useAppSelector from "../../../hooks/useAppSelector";
export default function useConnectEnabled() {
    return useAppSelector(function (state) {
        var onboard_connect_frontend = state.featureFlags.flags.onboard_connect_frontend;
        return isFlagOn(onboard_connect_frontend);
    });
}
